import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

export const pascalCase = (str) =>
    str !== null
        ? str
              .replace(/[^a-z0-9]+/gi, ' ')
              .replace(/(\w)(\w*)/g, (g0, g1, g2) => `${g1.toUpperCase()}${g2}`)
              .replace(/\s+/gi, '')
        : null;

export const isMessage = (message) => isObject(message) && typeof message.id !== 'undefined';

export const shuffle = (array) => {
    let currentIndex = array.length;
    let temporaryValue;
    let randomIndex;

    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex]; // eslint-disable-line
        array[randomIndex] = temporaryValue; // eslint-disable-line
    }

    return array;
};

export const getComponentFromName = (components, name, defaultComponentName = null) => {
    const defaultComponent =
        (isString(defaultComponentName)
            ? components[pascalCase(defaultComponentName)] || components[defaultComponentName]
            : defaultComponentName) || null;
    if (name === null) {
        return defaultComponent;
    }
    const componentName = pascalCase(name);
    return components[componentName] || components[name] || defaultComponent;
};

export const padStart = (string, maxLength, add = '') => {
    const str = String(string);
    if (str.length >= maxLength) {
        return str;
    }

    let fillString = String(add);
    if (fillString.length === 0) {
        fillString = ' ';
    }

    const fillLen = maxLength - str.length;
    const timesToRepeat = Math.ceil(fillLen / fillString.length);
    const truncatedStringFiller = fillString.repeat(timesToRepeat).slice(0, fillLen);
    return truncatedStringFiller + str;
};

export const formatCurrency = (amount) => {
    let i = parseFloat(amount);
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(i)) {
        i = 0.0;
    }
    let minus = '';
    if (i < 0) {
        minus = '-';
    }
    i = Math.abs(i);
    i = parseInt((i + 0.005) * 100, 10);
    i /= 100;
    // eslint-disable-next-line no-new-wrappers
    let s = new String(i);
    if (s.indexOf('.') < 0) {
        s += '.00';
    }
    if (s.indexOf('.') === s.length - 2) {
        s += '0';
    }
    s = minus + s;
    return s;
};

export const getImageSize = (image, size) =>
    image !== null && image !== undefined
        ? (image.sizes || []).find((it) => it.id === size) || image
        : null;

export const getImageSizeUrl = (image, size) => {
    const imageAtSize = getImageSize(image, size);
    return imageAtSize !== null ? imageAtSize.url || null : null;
};

export const getUniqueArray = (array, key = 'id') => {
    if (!array) {
        return array;
    }

    const uniqueIds = [];
    return array.filter((item) => {
        const valid = uniqueIds.indexOf(item[key]) === -1;
        uniqueIds.push(item.id);
        return valid;
    });
};
